var _path, _path2, _path3, _polyline, _path4, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFashionAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.913,4.856c0-1.153.934-2.087,2.087-2.087s2.087.934,2.087,2.087-.934,2.087-2.087,2.087v2.092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.994,39.231h-9.32s.07-.749.07-.749c.59-6.327,2.269-9.47,4.927-14.955h0s-3.244-10.828-3.244-10.828l1.753-1.493.75,1.279c1.242,2.118,3.155,4.167,5.07,4.17h-.006c1.915-.003,3.828-2.052,5.07-4.17l.75-1.279,1.753,1.493-3.244,10.828h0c2.659,5.485,4.338,8.628,4.927,14.955l.07.749h-9.326Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.375,15.862l-2.559,1.049c-.835.343-1.449-.814-.697-1.314l2.649-1.76"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24.541 14.597 21 13.145 21 13.145 17.455 14.599"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.232,13.838l2.649,1.76c.752.499.138,1.656-.697,1.314l-2.564-1.052"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "15.892 12.428 21 9.035 21 9.035 26.104 12.425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFashionAccessories);
export default __webpack_public_path__ + "static/media/indoor-fashion_accessories.88d5c8a390f64e4c50fcaad64e7dd04d.svg";
export { ForwardRef as ReactComponent };